import React, { useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
// import Banner from '../../components/banner/Banners.jsx';
import HeroSection from '../../components/herosection/HeroSection.jsx';
import About from '../../components/aboutus/About.jsx';
// import Categories from '../../components/categories/Categories.jsx';
import CTAHome from '../../components/cta/CTAHome.jsx';
import ContactUs from '../../components/contactus/Contact.jsx';
import FAQs from "../../components/whatsNew/FAQs.js"
import Blogs from "../../components/blogs/Blogs.js"
import TopServices from "../../components/topservices/TopServices.jsx"
import Testimonials from '../../components/testimonials/Testimonials.jsx';


const PublicHome = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <HeroSection />
      {/* <Categories /> */}
      <About />
      <TopServices />
      <CTAHome />
      <Blogs />
      <FAQs />
      <Testimonials />
      <ContactUs />

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/918011602251?text=🏕️%20I%20am%20visiting%20the%20Dimaniwas%20Campsite%20via%20your%20website%20and%20interested%20to%20book%20a%20tent,%20could%20you%20connect%20with%20me%3F"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp className="whatsapp-icon" />
      </a>

      <style>{`
        .whatsapp-float {
          position: fixed;
          width: 56px;
          height: 56px;
          bottom: 24px;
          right: 24px;
          background: linear-gradient(135deg, #25d366, #1db954);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 16px rgba(37, 211, 102, 0.45);
          z-index: 1000;
          transition: transform 0.25s ease, box-shadow 0.25s ease;
          cursor: pointer;
        }
        .whatsapp-float:hover {
          transform: scale(1.1) translateY(-2px);
          box-shadow: 0 8px 24px rgba(37, 211, 102, 0.6);
        }
        .whatsapp-icon {
          color: #ffffff;
          font-size: 28px;
          display: block;
        }
      `}</style>

    </div>
  );
};

export default PublicHome;